import React from "react";
import { useTranslation } from "react-i18next";
import "./clickAndFilter.scss";

function ClickAndFilter() {
  const { t } = useTranslation()

  return (
    <div className="container-click-and-filter">
      <div className="texts-click-and-filter">

        <div>
          <h1>{t("interactive_dashboards.click_and_filter.click.title")}</h1>
          <p>{t("interactive_dashboards.click_and_filter.click.section_text_1")}</p>
          <p>{t("interactive_dashboards.click_and_filter.click.section_text_2")}</p>
        </div>

        <br />

        <div>
          <h1>{t("interactive_dashboards.click_and_filter.users_and_teams.title")}</h1>
          <p>{t("interactive_dashboards.click_and_filter.users_and_teams.section_text_1")}</p>
          <p>{t("interactive_dashboards.click_and_filter.users_and_teams.section_text_2")}</p>
        </div>

        <br />

        <div>
          <h1>{t("interactive_dashboards.click_and_filter.table.title")}</h1>
          <p>{t("interactive_dashboards.click_and_filter.table.section_text_1")}</p>
          <p>{t("interactive_dashboards.click_and_filter.table.section_text_2")}</p>
        </div>

        <br />


        <div>
          <h1>{t("interactive_dashboards.click_and_filter.easy_nav.title")}</h1>
          <p>{t("interactive_dashboards.click_and_filter.easy_nav.section_text_1")}</p>
          <p>{t("interactive_dashboards.click_and_filter.easy_nav.section_text_2")}</p>
          <p>{t("interactive_dashboards.click_and_filter.easy_nav.section_text_3")}</p>
        </div>

      </div>
    </div>
  );
}

export default ClickAndFilter;
